<template>
  <button @click="$emit('click', $event)" class="filter-pill">
    <slot></slot>
    <CloseIcon class="fill-primary icon-size-sm"></CloseIcon>
  </button>
</template>

<script>
export default {
  emits: ['click'],
  name: "FilterPill.vue"
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.filter-pill {
  display: flex;
  gap: $spacing-xxs;
  background-color: transparent;
  border: 1px solid $brand-primary;
  padding: $spacing-xxs $spacing-xs;
  font-size: $font-size-small;
  margin: 0;
  border-radius: 9999px;
  color: $brand-primary
}
</style>
